import React, { useState } from "react";

import FormGroup from "../FormGroup";
import { getDisplayValue } from "../../../helpers/input";

import style from "./style.module.css";
import { trim } from "lodash";

export default function Input(props) {
    const [focus, setFocus] = useState(false);
    const { type, input: { value, onBlur, onChange, name }, placeholder, numberFormat = false, onKeyUpHandler, onKeyDown, disabled, maxLength, label, required, meta, helpText, autoComplete = "on", symbol, className, tooltip = false, minDecimals = 2, maxDecimals = 5 } = props;
    const { error = "" } = meta;
    const displayValue = getDisplayValue(value, numberFormat, focus, error, minDecimals, maxDecimals);

    const onBlurHandler = (e) => {
        onBlur(e);
        setTimeout(() => setFocus(false));
    }

    return (
        <FormGroup
            meta={meta}
            label={label}
            focus={focus}
            value={value}
            required={required}
            helpText={helpText}
            disabled={disabled}
            className={symbol ? 'symbol' : className}
            tooltip={tooltip}
            fieldName={name}
            fieldValue={value}
        >
            {
                symbol && (
                    <div className={style.symbol}>
                        {trim(symbol)}
                    </div>
                )
            }
            <input
                type={type}
                value={displayValue}
                placeholder={placeholder}
                onFocus={() => setFocus(true)}
                onKeyUp={onKeyUpHandler}
                onKeyDown={onKeyDown}
                disabled={disabled}
                className={`${style.textbox}${symbol ? " " + style.textboxSymbol : ""}`}
                maxLength={maxLength}
                onBlur={onBlurHandler}
                onChange={onChange}
                autoComplete={autoComplete}
                name={name}
            />
        </FormGroup>
    )
}